<template>
  <div class="about wrap">
    <SlotPageVisual class="half">
      <template #visual-bg>
        <div class="img history"></div>
      </template>
      <template #contents>
        <h1 class="visual-title">
          <span data-aos="fade"><span class="hl"> H</span>istory</span>
        </h1>
        <p class="visual-summary">
          <span data-aos="fade-up" data-aos-delay="1000">
            {{ $t('about.history.desc') }}
          </span>
        </p>
      </template>
    </SlotPageVisual>

    <section class="section history auto">
      <div class="section-contents bg-light">
        <div class="history-wrap" id="scrollArea">
          <div class="timeline" data-aos="fade-up">

            <div
              class="timeline-item"
              v-for="yearData in historyList"
              :key="yearData.year"
            >
              <!-- 왼쪽: 연도 -->
              <div class="timeline-left">
                <span class="timeline-year hl">{{ yearData.year }}</span>
              </div>

              <!-- 중앙: 선 + 점 -->
              <div class="timeline-center">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>

              <!-- 오른쪽: 월별 항목 -->
              <div class="timeline-right">
                <ul class="timeline-entries">
                  <li
                    class="timeline-entry"
                    v-for="(entry, idx) in yearData.months"
                    :key="idx"
                  >
                    <b class="entry-month">{{ entry.m }}</b>
                    <span class="entry-text">{{ entry.o }}</span>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SlotPageVisual from '@/components/SlotPageVisual'
import { progressScroll } from '@/mixin/progressScroll'

export default {
  mixins: [progressScroll],
  name: 'aboutView',
  components: {
    SlotPageVisual
  },
  props: {
    msg: String
  },
  data () {
    return {}
  },
  computed: {
    historyList () {
      const list = this.$tm('about.history.list')
      return Object.entries(list)
        .sort(([a], [b]) => Number(b) - Number(a))
        .map(([, yearData]) => ({
          year: yearData.year,
          months: Object.values(yearData.month)
        }))
    }
  }
}
</script>
